<template>
  <div>
    <e-sidebar
      :title="edit ? $t('Editar Departamento') : $t('Novo Departamento')"
      :show="showSidebar"
      :fetching="fetching"
      :saving="saving"
      width="500px"
      @save="saveDepartment"
      @hidden="hideSidebar"
    >
      <template #content>
        <div>
          <FormulateForm
            ref="departmentForm"
            name="form"
          >
            <FormulateInput
              id="department-name"
              v-model="localDepartment.name"
              type="text"
              class="required"
              :label="$t('Nome')"
              validation="required"
            />
          </FormulateForm>
        </div>
      </template>
    </e-sidebar>
  </div>
</template>

<script>
import { ESidebar } from '@/views/components'
import { mapActions } from 'vuex'

const getInitialLocalDepartment = () => ({
  id: null,
  name: null,
  active: null,
})

export default {
  components: {
    ESidebar,
  },

  mixins: [],

  props: {
    departmentId: {
      type: Number,
      default: null,
    },
    department: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      showSidebar: false,
      fetching: false,
      edit: false,
      saving: false,
      localDepartmentId: null,
      localDepartment: getInitialLocalDepartment(),
    }
  },

  watch: {
    department(val) {
      this.localDepartment = val
    },
    departmentId(val) {
      this.localDepartmentId = val
    },
    async localDepartmentId(val) {
      if (val) {
        try {
          this.fetching = true
          const { data: localDepartment } = await this.$http.get(
            `/api/departments/${this.localDepartmentId}`
          )
          this.localDepartment = localDepartment
        } catch (error) {
          this.showGenericError({ error })
        } finally {
          this.fetching = false
        }
      } else {
        this.localDepartment = getInitialLocalDepartment()
      }
    },
  },

  methods: {
    ...mapActions('pages/catalog/products', { comboFetchDomainData: 'fetchDomainData' }),

    showCreate() {
      this.localDepartment = getInitialLocalDepartment()
      this.edit = false
      this.showSidebar = true
    },

    async show({ id, item } = {}) {
      if (!id && !item?.id) {
        this.showCreate()
      } else {
        if (id) this.localDepartmentId = id
        if (item) this.localDepartment = item
        this.edit = true
        this.showSidebar = true
      }
    },

    hideSidebar() {
      this.localDepartment = getInitialLocalDepartment()
      this.localDepartmentId = null
      this.showSidebar = false
    },

    async saveDepartment() {
      this.$refs.departmentForm.showErrors()
      if (this.$refs.departmentForm.isValid) {
        try {
          this.saving = true

          const body = {
            id: this.localDepartment.id,
            name: this.localDepartment.name,
            active: this.localDepartment.active,
          }
          const result = await this.$http({
            url: '/api/departments',
            method: this.edit ? 'PUT' : 'POST',
            data: body,
          })
          this.comboFetchDomainData('departments')
          this.showSuccess({
            message: this.$t(`${this.edit ? 'Atualização' : 'Inclusão'} realizada com sucesso`),
          })
          this.showSidebar = false
          this.$emit('save', result.data)
        } catch (error) {
          this.showError({ error })
        } finally {
          this.saving = false
        }
      } else {
        this.showInvalidDataMessage()
      }
    },
  },
}
</script>

<style></style>
